import { HttpClient } from '@angular/common/http';
import { Component, inject, type OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import * as UserArchive from '../../../server/routes/users/archive';
import { generatePath } from '../../../server/services/utils.service';
import type { Org, OrgUser } from '../../../server/types/org-types';
import type { DeepReadonly } from '../../../server/util-type';
import { AuthUserService } from '../auth-user.service';

export type UserArchiveDialogComponentData = {
  org: DeepReadonly<Org>;
  user: DeepReadonly<OrgUser>;
};

@Component({
  selector: 'app-user-archive-dialog',
  templateUrl: './user-archive-dialog.component.html',
  styleUrls: ['./user-archive-dialog.component.scss'],
  standalone: false,
})
export class UserArchiveDialogComponent implements OnDestroy {
  private dialogRef = inject(MatDialogRef<UserArchiveDialogComponent>);
  private readonly data: UserArchiveDialogComponentData =
    inject(MAT_DIALOG_DATA);
  private http = inject(HttpClient);
  private snackBar = inject(MatSnackBar);
  private authUserService = inject(AuthUserService);

  org: DeepReadonly<Org>;
  user: DeepReadonly<OrgUser>;
  subscriptions = new Subscription();

  constructor() {
    this.org = this.data.org;
    this.user = this.data.user;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  accept(): void {
    const path = generatePath<UserArchive.ReqParams>(
      '/api/orgs/:orgId/users/:userId/archive',
      { orgId: this.org._id, userId: this.user._id }
    );
    const body: UserArchive.ReqBody = {};
    const sub = this.http.post<UserArchive.ResBody>(path, body).subscribe({
      next: ({ org }) => {
        this.authUserService.updateOrg({ org });

        this.dialogRef.close();
      },
      error: (err) => {
        this.snackBar.open('ERROR: could not archive user.', 'Dismiss', {
          duration: 5000,
        });
        this.dialogRef.close();
      },
    });
    this.subscriptions.add(sub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
